import { Utils } from '../libraries';
import { EnumApiBffsvr } from './bffsvr';
import { EnumApiCommodity } from './commodity';
import { EnumApiCommon } from './common';
import { EnumApiCompany } from './company';
import { EnumApiCompanyCert } from './companyCert';
import { EnumApiContent } from './content';
import { EnumApiIdass } from './idass';
import { EnumApiLive } from './live';
import { EnumApiPartner } from './partner';
import { EnumApiRegionorg } from './regionorg';
import { EnumApiUsersvr } from './usersvr';
import { EnumApiWechat } from './wechat';
export const EnumAPI = {
    ...new EnumApiBffsvr(),
    ...new EnumApiCommodity(),
    ...new EnumApiCommon(),
    ...new EnumApiWechat(),
    ...new EnumApiUsersvr(),
    ...new EnumApiCompanyCert(),
    ...new EnumApiIdass(),
    ...new EnumApiRegionorg(),
    ...new EnumApiCompany(),
    ...new EnumApiPartner(),
    ...new EnumApiContent(),
    ...new EnumApiLive(),
};
Utils.toReadonly(EnumAPI);
